import _ from 'lodash';

/**
 * Merge Ant Form rules without dropping function rules (e.g. `() => ({ validator })`).
 * Spreading a function yields `{}`, which used to be filtered out and silently
 * removed URL/custom validators.
 */
export function mergeUniqueRules(rules = [], changed = []) {
  const merged = changed.map((o) => (_.isFunction(o) ? o : { ...o }));

  for (const r of rules) {
    if (_.isFunction(r)) {
      merged.push(r);
      continue;
    }

    const target = merged.find(
      (o) => !_.isFunction(o) && Object.keys(o).some((k) => Object.keys(r).includes(k)),
    );
    if (target) {
      for (const [k, v] of Object.entries(r)) {
        if (!(k in target)) target[k] = v;
      }
    } else if (!_.isEmpty(r)) {
      merged.push({ ...r });
    }
  }

  return merged.filter((o) => _.isFunction(o) || !_.isEmpty(o));
}
